import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeFourComponent} from './home-4/home-four.component';
import {CollectionLeftSidebarComponent} from './product/collection/collection-left-sidebar/collection-left-sidebar.component';
import {CollectionNoSidebarComponent} from './product/collection/collection-no-sidebar/collection-no-sidebar.component';
import {ProductLeftSidebarComponent} from './product/product-details/product-left-sidebar/product-left-sidebar.component';
import {ProductNoSidebarComponent} from './product/product-details/product-no-sidebar/product-no-sidebar.component';
import {ProductColLeftComponent} from './product/product-details/product-col-left/product-col-left.component';
import {ProductColRightComponent} from './product/product-details/product-col-right/product-col-right.component';
import {ProductColumnComponent} from './product/product-details/product-column/product-column.component';
import {ProductAccordianComponent} from './product/product-details/product-accordian/product-accordian.component';
import {ProductLeftImageComponent} from './product/product-details/product-left-image/product-left-image.component';
import {ProductRightImageComponent} from './product/product-details/product-right-image/product-right-image.component';
import {ProductVerticalTabComponent} from './product/product-details/product-vertical-tab/product-vertical-tab.component';

import {CartComponent} from './product/cart/cart.component';
import {CheckoutComponent} from './product/checkout/checkout.component';
import {SuccessComponent} from './product/success/success.component';
import {SearchComponent} from './home-4/search/search.component';


// Routes
const routes: Routes = [
  {
    path: '',
    component: HomeFourComponent
  },
  {
    path: 'search/:article',
    component: SearchComponent
  },
  {
    path: 'articlesDepartment/:departmentId',
    component: HomeFourComponent
  },
  {
    path: 'left-sidebar/collection/:category',
    component: CollectionLeftSidebarComponent
  },  
  {
    path: 'no-sidebar/collection/:category',
    component: CollectionNoSidebarComponent
  },
  {
    path: 'left-sidebar/product/:id',
    component: ProductLeftSidebarComponent
  },
  {
    path: 'no-sidebar/product/:id',
    component: ProductNoSidebarComponent
  },
  {
    path: 'col-left/product/:id',
    component: ProductColLeftComponent
  },
  {
    path: 'col-right/product/:id',
    component: ProductColRightComponent
  },
  {
    path: 'column/product/:id',
    component: ProductColumnComponent
  },
  {
    path: 'accordian/product/:id',
    component: ProductAccordianComponent
  },
  {
    path: 'left-image/product/:id',
    component: ProductLeftImageComponent
  },
  {
    path: 'right-image/product/:id',
    component: ProductRightImageComponent
  },
  {
    path: 'vertical/product/:id',
    component: ProductVerticalTabComponent
  },
  {
    path: 'cart',
    component: CartComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  },
  {
    path: 'checkout/success/:id',
    component: SuccessComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
